import { isAnyOf } from "@reduxjs/toolkit";

import { cleanUpBillingLocationsList } from "../../reducers/billingLocationsReducer";
import { cleanUpBilling, getBillingThunk, putUpdateBillingThunk } from "../../reducers/billingReducer";
import { startAppListening } from "./listenerMiddleware";
import { resetBillingLocationsList } from "./utils/resetBillingLocationsList";

export const billingListener = (): void => {
  startAppListening({
    matcher: isAnyOf(getBillingThunk.pending),
    effect: async (_, { dispatch }) => {
      dispatch(cleanUpBilling());
      dispatch(cleanUpBillingLocationsList());
    },
  });
  startAppListening({
    matcher: isAnyOf(putUpdateBillingThunk.fulfilled),
    effect: async (_, { dispatch }) => {
      resetBillingLocationsList(dispatch);
    },
  });
};
